export interface ChangeQuantity {
	quantity: number;
}

export class ChangeQuantity implements ChangeQuantity {
	constructor(data?: Partial<ChangeQuantity>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}